// Preview popup state management

// Preview popup state
export let previewPopupElement = null;
export let previewPopupTimeout = null;
export let previewHoverTimeout = null;
export let currentPreviewFile = null;
export let previewPopupHovered = false;
export let previewIconHovered = false;
export let previewPopupPinned = false;
export let pdfBlobUrl = null;
export let originalBodyOverflow = null; // Store original body overscroll-behavior for restoration
export let originalHtmlOverscroll = null; // Store original html overscroll-behavior for restoration
export let globalWheelHandler = null; // Store global wheel handler for cleanup
export let windowResizeHandler = null; // Store window resize fail-safe handler for cleanup
export let navKeyHandler = null; // Store preview prev/next keyboard handler for cleanup
export let setPinnedCallback = null; // Store setPinned callback for use when switching documents

// Preview popup configuration
export const PREVIEW_POPUP_HIDE_DELAY = 1000;
export const PREVIEW_POSITION_COOKIE_NAME = 'preview_popup_position';
export const PREVIEW_SIZE_COOKIE_NAME = 'preview_popup_size';

// State getters/setters for event handlers
export function getPreviewState() {
	return {
		previewPopupElement,
		previewPopupTimeout,
		previewHoverTimeout,
		currentPreviewFile,
		previewPopupHovered,
		previewIconHovered,
		previewPopupPinned,
		pdfBlobUrl,
		originalBodyOverflow,
		originalHtmlOverscroll,
		globalWheelHandler,
		windowResizeHandler,
		navKeyHandler,
		setPinnedCallback,
		PREVIEW_POPUP_HIDE_DELAY
	};
}

export function setPreviewState(state) {
	previewPopupElement = state.previewPopupElement;
	previewPopupTimeout = state.previewPopupTimeout;
	previewHoverTimeout = state.previewHoverTimeout;
	currentPreviewFile = state.currentPreviewFile;
	previewPopupHovered = state.previewPopupHovered;
	previewIconHovered = state.previewIconHovered;
	previewPopupPinned = state.previewPopupPinned !== undefined ? state.previewPopupPinned : false;
	pdfBlobUrl = state.pdfBlobUrl !== undefined ? state.pdfBlobUrl : null;
	originalBodyOverflow = state.originalBodyOverflow !== undefined ? state.originalBodyOverflow : null;
	originalHtmlOverscroll = state.originalHtmlOverscroll !== undefined ? state.originalHtmlOverscroll : null;
	globalWheelHandler = state.globalWheelHandler !== undefined ? state.globalWheelHandler : null;
	windowResizeHandler = state.windowResizeHandler !== undefined ? state.windowResizeHandler : null;
	navKeyHandler = state.navKeyHandler !== undefined ? state.navKeyHandler : null;
	setPinnedCallback = state.setPinnedCallback !== undefined ? state.setPinnedCallback : null;
}

